module.exports = __webpack_public_path__ + "static/media/grin-hearts.df92da58.svg";